import React from 'react';

interface IconProps {
  fill: string;
  height: string;
  width: string;
}

function EmployeesIcon({ fill, height, width }: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none" viewBox="0 0 34 34">
      <path
        fill={fill}
        d="M30.334 8.667h-8.333v-5C22 1.833 20.5.333 18.667.333h-3.333a3.343 3.343 0 00-3.333 3.334v5H3.667A3.343 3.343 0 00.334 12v18.333c0 1.834 1.5 3.334 3.333 3.334h26.667c1.833 0 3.333-1.5 3.333-3.334V12c0-1.833-1.5-3.333-3.333-3.333zM12.001 17c1.383 0 2.5 1.117 2.5 2.5S13.384 22 12 22a2.497 2.497 0 01-2.5-2.5c0-1.383 1.116-2.5 2.5-2.5zm5 10H7v-1.25c0-1.667 3.333-2.5 5-2.5 1.666 0 5 .833 5 2.5V27zm1.666-15h-3.333V3.667h3.333V12zm8.334 12.5h-6.667V22h6.667v2.5zm0-5h-6.667V17h6.667v2.5z"
      ></path>
    </svg>
  );
}

export default EmployeesIcon;
